import React, { memo, useEffect, useState } from 'react'
import styles from './index.module.less'
import classNames from 'classnames'
import { Dropdown, MenuProps } from 'antd'
import logoIcon from '@/assets/image/logo.svg'

/** 导航图片 */
import RollupIcon from '@/assets/image/header/rollup.png'
import RollupSelectIcon from '@/assets/image/header/rollup-select.png'
/* 图片 */
import img_menu from '@/assets/image/menu.png'
import { initialLanguageArr, langTextMap } from '@/i18n/config.js'
import { useTranslation } from 'react-i18next'
import { setLanguage } from '@/i18n/lang'
import useMeNavigate from '@/hooks/useMeNavigate'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import { useLocation } from 'react-router-dom'
import type { WindowType } from '@/vite-env'
dayjs.extend(utc)

const Header = ({ isOldVersion = false }: { isOldVersion: boolean }) => {
  const { t, i18n } = useTranslation()
  const [navConfig, setNavConfig] = useState([
    {
      // 国家区
      name: 'explorer_1',
      key: 'countryRegion',
      path: '/countryRegion',
      activePath: ['/countryRegion'],
    },
    // {
    //   // 验证节点
    //   name: 'explorer_2',
    //   key: 'verifynodes',
    //   path: '/verifynodes',
    //   activePath: ['/verifynodes'],
    // },
    {
      name: 'explorer_3',
      key: 'blockchain',
      path: '/blockchain',
      activePath: ['/blockchain'],
    },
    {
      // 交易
      name: 'explorer_4',
      key: 'transaction',
      path: '/transaction',
      activePath: ['/transaction', '/accountDetail', '/moduleAccount'],
      hover: false,
    },
    // {
    //   icon: RollupIcon,
    //   activeIcon: RollupSelectIcon,
    //   name: 'Rollup',
    //   key: 'rollup',
    //   path: '/rollup',
    //   activePath: ['/rollup'],
    // },
    // {
    //   // 节点提案

    //   name: 'explorer_5',
    //   key: 'proposal',
    //   path: '/proposal',
    //   activePath: ['/proposal'],
    // },
    {
      // 地址公示
      name: 'explorer_6',
      key: 'addressPublicity',
      path: '/addressPublicity',
      activePath: ['/addressPublicity'],
      hover: false,
    },
    {
      // gc 浏览器
      name: 'explorer_311',
      key: 'gc_explorer',
      path: import.meta.env.VITE_GC_EXPLORER_URL,
      activePath: [import.meta.env.VITE_GC_EXPLORER_URL],
      hover: false,
    },
  ])
  const [showMenu, setShowMenu] = useState(false)
  const navigate = useMeNavigate()
  const location = useLocation()
  const [showMiniMenu, setShowMiniMenu] = useState(false)
  const [currentTime, setCurrentTime] = useState(dayjs.utc().format('YYYY-MM-DD HH:mm:ss'))
  const [languageOpen, setLanguageOpen] = useState(false)

  // 语言选项
  const LANGUAGES_OPTIONS: MenuProps['items'] = initialLanguageArr.map((item) => {
    return {
      label: item.langName,
      key: item.langValue,
    }
  })

  const handleLangClick: MenuProps['onClick'] = (e) => {
    // 切换语言时记录当前语言
    ;(window as unknown as WindowType).lastLanguage = i18n.language
    setLanguage(e.key)
    // setTimeout(() => {
    //   setShowMenu(false)
    // }, 100)
  }
  const LANGUAGES = {
    items: LANGUAGES_OPTIONS,
    onClick: handleLangClick,
    selectedKeys: [i18n.language],
  }

  const onOpenMenu = () => {
    setShowMenu(!showMenu)
  }

  useEffect(() => {
    // 初始化时记录当前语言
    ;(window as unknown as WindowType).lastLanguage = i18n.language
    // 初始化时记录当前地址
    ;(window as unknown as WindowType).lastPath = location.pathname
    localStorage.setItem('currentPath', location.pathname)

    const interval = setInterval(() => {
      setCurrentTime(dayjs.utc().format('YYYY-MM-DD HH:mm:ss'))
    }, 1000) // 每秒更新一次

    return () => clearInterval(interval) // 清除定时器
  }, [])

  useEffect(() => {
    if (showMenu) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'auto'
    }
  }, [showMenu])

  const renderUTCTime = () => {
    return (
      <div className={classNames(styles.utc_time)}>
        <div className={styles.utc_time_content}>
          <span>UTC+0:{currentTime}</span>
        </div>
      </div>
    )
  }

  const handleLanguageOpenChange = (open: boolean) => {
    setLanguageOpen(open)
  }

  const handleNavigate = (path: string) => {
    // 如果路径是GC浏览器地址，则打开新窗口
    if (path === import.meta.env.VITE_GC_EXPLORER_URL) {
      window.open(path, '_blank')
      return
    }
    // // 记录跳转前路径
    // ;(window as unknown as WindowType).lastPath = location.pathname
    // // 存储当前路径
    // localStorage.setItem('currentPath', path)
    navigate(path)
  }

  // ✅ 修复后
  useEffect(() => {
    localStorage.setItem('currentPath', location.pathname)
    return () => {
      ;(window as unknown as WindowType).lastPath = location.pathname
    }
  }, [location.pathname])

  const getisActive = (activePath: string[], path: string) => {
    return activePath.some((item) => path.includes(item))
  }

  const [isHomePage, setIsHomePage] = useState(false)

  useEffect(() => {
    setIsHomePage(location.pathname.includes('/home'))
  }, [location])

  useEffect(() => {
    // 判断菜单出现时机
    const mediaQuery = window.matchMedia('(max-width: 1300px)')
    if (mediaQuery.matches) {
      setShowMiniMenu(true)
    } else {
      setShowMiniMenu(false)
    }
    mediaQuery.addEventListener('change', (event) => {
      if (event.matches) {
        setShowMiniMenu(true)
      } else {
        setShowMiniMenu(false)
        setShowMenu(false)
      }
    })
  }, [])

  return (
    <>
      <div
        className={classNames({
          layout_header_wrap: true,
          layout_header_wrap_mini: showMiniMenu,
          layout_header_wrap_old: isOldVersion,
        })}
      >
        <div
          className={classNames({
            [styles.layout_header]: true,
            ['layout_header']: true,
            [styles.layout_header_old]: isOldVersion,
          })}
        >
          <div
            className={classNames({
              [styles.HeaderWrap]: true,
              ['layout_header_nav1']: true,
              [styles.HeaderWrapOld]: isOldVersion,
            })}
          >
            <div className={classNames(styles.Logo, isHomePage ? styles.isHomePage : '')}>
              <img
                src={logoIcon}
                alt="logo"
                className={'logo_img'}
                onClick={() => {
                  if (showMenu) {
                    setShowMenu(false)
                  }
                  if (isHomePage) {
                    return
                  }
                  handleNavigate('/home')
                }}
              />
            </div>

            <div className={styles.navTabwrap}>
              {!showMiniMenu &&
                navConfig.map((item) => {
                  const isActive = getisActive(item.activePath, location.pathname)
                  return (
                    <div
                      key={item.path}
                      onClick={() => handleNavigate(item.path)}
                      className={classNames(styles.navTabwrapItem, {
                        [styles.headerNavTabItemIsActive]: isActive,
                      })}
                    >
                      <span
                        className={classNames({
                          [styles.navTabwrapItemIcon]: true,
                          [styles[`header_nav_icon_${item.key}`]]: true,
                          [styles[`header_nav_icon_${item.key}_isActive`]]: isActive,
                        })}
                      ></span>
                      <span
                        className={classNames({
                          [styles.navTabwrapItemSpan]: true,
                        })}
                      >
                        {t(item.name)}
                      </span>
                    </div>
                  )
                })}
              {showMiniMenu && !isOldVersion ? (
                !showMenu ? (
                  <img
                    onClick={onOpenMenu}
                    className={'header_right_mini_icon'}
                    src={img_menu}
                    alt=""
                  />
                ) : (
                  <div onClick={onOpenMenu} className={styles.header_right_close_bgn}></div>
                )
              ) : null}
            </div>
          </div>
          {isOldVersion ? (
            <>
              <div
                className={classNames('layout_header_nav2_wrap', {
                  [styles.layout_header_nav2_wrap_old]: isOldVersion,
                })}
              >
                <div
                  className={classNames('layout_header_nav2', {
                    [styles.layout_header_nav2_12_old]: isOldVersion,
                  })}
                >
                  <>
                    <span className={`global_header_right`}>{renderUTCTime()}</span>
                    {/* 不需要展示国家 */}
                    <Dropdown
                      menu={LANGUAGES}
                      trigger={['click']}
                      overlayClassName="global_dropdown"
                      onOpenChange={handleLanguageOpenChange}
                    >
                      <div className={styles.languagewrap}>
                        <span className={styles.languageIcon}></span>
                        <span>{langTextMap[i18n.language]}</span>
                        <span
                          className={classNames({
                            [styles.Trsrow]: true,
                            [styles['rotate']]: languageOpen,
                          })}
                        ></span>
                      </div>
                    </Dropdown>
                    <div
                      className={classNames(styles.change_old_version, `global_header_right`)}
                      onClick={() => {
                        window.open('https://explorer.gea-chain.com/')
                      }}
                    >
                      {/* 切换旧版 */}
                      <span>{t('explorer_221')}</span>
                      <i className={styles.changeOldVersionIcon}></i>
                    </div>
                    {showMiniMenu && isOldVersion ? (
                      !showMenu ? (
                        <img
                          onClick={onOpenMenu}
                          className={'header_right_mini_icon'}
                          src={img_menu}
                          alt=""
                        />
                      ) : (
                        <div onClick={onOpenMenu} className={styles.header_right_close_bgn}></div>
                      )
                    ) : null}
                  </>
                </div>
              </div>
            </>
          ) : null}
        </div>
        {!isOldVersion ? (
          <>
            <div className={'layout_header_nav2_wrap'}>
              <div className="layout_header_nav2">
                <>
                  <span className={`global_header_right`}>{renderUTCTime()}</span>
                  {/* 不需要展示国家 */}
                  <Dropdown
                    menu={LANGUAGES}
                    trigger={['click']}
                    overlayClassName="global_dropdown"
                    onOpenChange={handleLanguageOpenChange}
                  >
                    <div className={styles.languagewrap}>
                      <span className={styles.languageIcon}></span>
                      <span>{langTextMap[i18n.language]}</span>
                      <span
                        className={classNames({
                          [styles.Trsrow]: true,
                          [styles['rotate']]: languageOpen,
                        })}
                      ></span>
                    </div>
                  </Dropdown>
                  <div
                    className={classNames(styles.change_old_version, `global_header_right`)}
                    onClick={() => {
                      window.open('https://explorer.gea-chain.com/')
                    }}
                  >
                    {/* 切换旧版 */}
                    <span>{t('explorer_221')}</span>
                    <i className={styles.changeOldVersionIcon}></i>
                  </div>
                </>
              </div>
            </div>
          </>
        ) : null}
      </div>
      <div
        className={classNames({
          [styles.cus_menu_wrap]: true,
          [styles.cus_menu_wrap_active]: showMenu,
        })}
      >
        <div className={styles.cus_menu_item}>
          {navConfig.map((item, index) => {
            const isActive = getisActive(item.activePath, location.pathname)
            return (
              <div
                key={index}
                className={classNames({
                  [styles.cus_menu_item_inner]: true,
                  [styles.navTabwrapItemaa]: true,
                  [styles.headerNavTabItemIsActive]: isActive,
                })}
                onClick={() => {
                  handleNavigate(item.path)
                  setShowMenu(false)
                }}
              >
                <span
                  className={classNames({
                    [styles.navTabwrapItemIcon]: true,
                    [styles.navTabwrapItemIconMobile]: true,
                    [styles[`header_nav_icon_${item.key}`]]: true,
                    [styles[`header_nav_icon_${item.key}_isActive`]]: isActive,
                  })}
                ></span>
                <span
                  className={classNames({
                    [styles.navTabwrapItemSpan]: true,
                  })}
                >
                  {t(item.name)}
                </span>
              </div>
            )
          })}
        </div>
        <div className={styles.menu_time}>
          {!isOldVersion ? (
            <>
              <Dropdown
                menu={LANGUAGES}
                trigger={['click']}
                overlayClassName="global_dropdown"
                onOpenChange={handleLanguageOpenChange}
              >
                <div className={styles.languagewrap}>
                  <span className={styles.languageIcon}></span>
                  <span>{langTextMap[i18n.language]}</span>
                  <span
                    className={classNames({
                      [styles.Trsrow]: true,
                      [styles['rotate']]: languageOpen,
                    })}
                  ></span>
                </div>
              </Dropdown>
            </>
          ) : null}
          <div
            className={classNames({
              [styles.change_old_version]: true,
              [styles.change_old_version_mini]: showMiniMenu,
            })}
            onClick={() => {
              window.open('https://explorer.gea-chain.com')
            }}
          >
            <span>{t('explorer_221')}</span>
            <i className={styles.changeOldVersionIcon}></i>
          </div>
          <span>UTC+0:{currentTime}</span>
        </div>
      </div>
    </>
  )
}

export default memo(Header)
